import { SELECIONAR_ASSENTO_ITINERARIO_IDA } from '../types'

export default function selecionarAssentoItinerarioIda (assento, fileira) {
  return {
    type: SELECIONAR_ASSENTO_ITINERARIO_IDA,
    payload: { assento, fileira }
  }
}
